import React, { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import moment from "moment"
import "moment/locale/pt-br"
import birthdayService from "../../services/data/birthday.service"

const REACTIONS = [
    { value: "cake", label: "🎂" },
    { value: "party", label: "🎉" },
    { value: "heart", label: "❤️" },
    { value: "star", label: "⭐" },
    { value: "clap", label: "👏" },
]

export default function BirthdayMural({ employeeId, employeeName }) {
    const companyId = localStorage.getItem("companyId")
    const [wishes, setWishes] = useState([])
    const [message, setMessage] = useState("")
    const [reaction, setReaction] = useState("party")
    const [loading, setLoading] = useState(false)
    const [submitting, setSubmitting] = useState(false)

    useEffect(() => {
        loadWishes()
    }, [employeeId])

    function loadWishes() {
        setLoading(true)
        birthdayService.getWishes(employeeId, { company_id: companyId })
            .then(setWishes)
            .catch(console.error)
            .finally(() => setLoading(false))
    }

    function handleSubmit(e) {
        e.preventDefault()
        if (!message.trim()) return
        setSubmitting(true)
        birthdayService.createWish({
            company_id: companyId,
            employee: employeeId,
            message,
            reaction,
        }).then(() => {
            setMessage("")
            loadWishes()
        }).catch(console.error)
          .finally(() => setSubmitting(false))
    }

    return (
        <div>
            <div className="bg-white rounded border-clean p-3 mb-3">
                <h6 className="text-default fw-bold mb-3">
                    <FontAwesomeIcon icon={solid("comments")} className="me-2 text-green" />
                    Mural de Parabéns{employeeName ? ` — ${employeeName}` : ""}
                </h6>

                <form onSubmit={handleSubmit} className="mb-4">
                    <div className="mb-2">
                        <textarea
                            className="form-control"
                            rows={3}
                            placeholder="Escreva sua mensagem de aniversário..."
                            value={message}
                            onChange={e => setMessage(e.target.value)}
                        />
                    </div>
                    <div className="d-flex align-items-center gap-3">
                        <div className="d-flex gap-1">
                            {REACTIONS.map(r => (
                                <button
                                    key={r.value}
                                    type="button"
                                    className={`btn btn-sm ${reaction === r.value ? "btn-success" : "btn-outline-secondary"}`}
                                    onClick={() => setReaction(r.value)}
                                    title={r.value}
                                >
                                    {r.label}
                                </button>
                            ))}
                        </div>
                        <button type="submit" className="btn btn-success btn-sm ms-auto" disabled={submitting}>
                            <FontAwesomeIcon icon={solid("paper-plane")} className="me-1" />
                            Enviar
                        </button>
                    </div>
                </form>

                {loading && <div className="text-muted small">Carregando mensagens...</div>}

                {wishes.length === 0 && !loading && (
                    <div className="text-muted small text-center py-3">
                        Nenhuma mensagem ainda. Seja o primeiro!
                    </div>
                )}

                {wishes.map(w => (
                    <div key={w.id} className="d-flex gap-3 py-2 border-bottom">
                        {w.author_photo
                            ? <img src={w.author_photo} alt={w.author_name} width="36" height="36" className="rounded-circle object-fit-cover" />
                            : <div className="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 36, height: 36, fontSize: 13 }}>
                                {w.author_name?.[0] || "?"}
                            </div>
                        }
                        <div className="flex-grow-1">
                            <div className="d-flex justify-content-between align-items-center">
                                <span className="fw-semibold small text-default">{w.author_name}</span>
                                <span className="text-muted" style={{ fontSize: "0.7rem" }}>
                                    {moment(w.created_at).fromNow()}
                                </span>
                            </div>
                            <div className="small mt-1">{w.message}</div>
                            {w.reaction_display && (
                                <span className="mt-1 d-inline-block">{w.reaction_display}</span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
